import { render } from "./NotificationsResctrictions.vue?vue&type=template&id=45a3c11a&scoped=true&ts=true"
import script from "./NotificationsResctrictions.vue?vue&type=script&lang=ts"
export * from "./NotificationsResctrictions.vue?vue&type=script&lang=ts"

import "./NotificationsResctrictions.vue?vue&type=style&index=0&id=45a3c11a&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a3c11a"]])

export default __exports__